<script setup lang="ts">
/**
 * Premade transition for fading opacity in and out achieved via tailwind
 */
</script>

<template>
  <Transition
    enter-active-class="transition-all duration-200 ease-out"
    leave-active-class="transition-all duration-200 ease-in"
    enter-from-class="opacity-0"
    leave-to-class="opacity-0"
  >
    <!-- rule is not valid here as the thing passed into slot will have a v-if -->
    <!-- eslint-disable-next-line vue/require-toggle-inside-transition -->
    <slot />
  </Transition>
</template>
